import { Controller } from "@hotwired/stimulus"

export default class LgpdController extends Controller {
  static targets = ["banner"]
  declare readonly bannerTarget: HTMLElement

  connect() {
    if (!this.hasChoice()) {
      this.bannerTarget.classList.remove("hidden")
    }
  }

  accept() {
    this.setCookie("1")
    this.hide()
    this.dispatch("accepted")
  }

  reject() {
    this.setCookie("0")
    this.hide()
  }

  private hasChoice(): boolean {
    return document.cookie.split(";").some((c) => c.trim().startsWith("lgpd_consent="))
  }

  private setCookie(value: string) {
    const maxAge = 365 * 24 * 60 * 60
    document.cookie = `lgpd_consent=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
  }

  private hide() {
    this.bannerTarget.classList.add("hidden")
  }
}
